import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '../queryKeys';
import { setAxiosAuth } from 'utils';
import { assetsApi } from 'core/api/assets.api';

export interface UseGetPortalRateType {
  equipmentId?: string;
  accessToken?: string;
}

export const useGetEquipmentRate = ({ equipmentId, accessToken = '' }: UseGetPortalRateType) => {
  setAxiosAuth(accessToken);

  return useQuery({
    queryKey: [queryKeys.equipmentRate, equipmentId],
    queryFn: async () => await assetsApi.getAssetRate(equipmentId),
    staleTime: 1000 * 60 * 5,
    enabled: Boolean(accessToken && equipmentId),
  });
}
